import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'wep-tpl-static-footer',
    templateUrl: './footer.html',
    host: {'class': 'wep-tpl-static-footer'},
    styleUrls: ['./footer.scss'],
})
export class FooterComponent {
    private router: Router;
    public year:number;
    public nffBadge:string = require('~/assets/images/pages/staticPage/nff-badge.png');
    constructor(router: Router
        
    ) {
        this.router = router; 
        this.year = new Date().getFullYear();
    }
    public goToTop() {
        window.scrollTo(0, 0);
    }
    public goToContact() : void {
        this.router.navigate(['/contact-us']);
    }
}